/**
 * DataZoom component entry
 */


    require('./dataZoom/typeDefaulter');

    require('./dataZoom/DataZoomModel');
    require('./dataZoom/DataZoomView');

    require('./dataZoom/SliderZoomModel');
    require('./dataZoom/SliderZoomView');

    require('./dataZoom/InsideZoomModel');
    require('./dataZoom/InsideZoomView');

    require('./dataZoom/dataZoomProcessor');
    require('./dataZoom/dataZoomAction');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/dataZoom.js
// module id = 1424
// module chunks = 1